import React, { useState, useEffect } from "react";
import DynamicLayout from "../components/DynamicLayout";
import saturnwallpaper from "../img/saturnwallpaper.jpg";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faClock } from '@fortawesome/free-solid-svg-icons';
import 'bulma/css/bulma.min.css'; // Ensure Bulma CSS is imported
import { useAuth } from '../context/authContext';
import { useFirebase } from '../context/firebaseContext';
import { doc, getDoc } from 'firebase/firestore';

const AcademyPage = () => {
  const [hoveredLock, setHoveredLock] = useState(null);
  const { db } = useFirebase();
  const { user: currentUser, loading: authLoading } = useAuth();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (!authLoading && currentUser) {
      const userDocRef = doc(db, 'users', currentUser.uid);
      getDoc(userDocRef).then((userDoc) => {
        if (userDoc.exists()) setUserData(userDoc.data());
      });
    }
  }, [authLoading, currentUser, db]);

  const isGold = userData?.accountType === 'gold';

  // Lock all courses if not gold
  const courses = [
    { name: "Astrology", path: "/academy/astrology", completed: 0, locked: !isGold },
    { name: "Tarot", path: "/academy/tarot", completed: 0, locked: !isGold },
    { name: "Runes", path: "/academy/runes", completed: 0, locked: !isGold },
    { name: "Numerology", path: "/academy/numerology", completed: 0, locked: !isGold },
    { name: "Kabbalah", path: "/academy/kabbalah", completed: 0, locked: true, comingSoon: true },
  ];

  const specializations = [
    { name: "Tarot and Astrology", path: "/academy/tarotandastrology", completed: 0, locked: true },
    { name: "Tarot and Numerology", path: "/academy/tarotandnumerology", completed: 0, locked: true },
    { name: "Tarot and the Kabbalah", path: "/academy/tarotandkabbalah", completed: 0, locked: true },
    { name: "Kabbalah and Astrology", path: "/academy/kaballahandastrology", completed: 0, locked: true },
    { name: "Kabbalah and Numerology", path: "/academy/kaballahandastrology", completed: 0, locked: true },
  ];

  const renderCourse = (course, index) => (
    <div key={index} className="box transparentbox mb-2" style={{ padding: '15px' }}>
      <div className="is-flex is-justify-content-space-between is-align-items-center">
        <div className="is-flex is-align-items-center" style={{ flex: '1', minWidth: '0', maxWidth: '200px' }}>
          <p className="has-text-medium has-text-warning" style={{ 
            margin: '0', 
            whiteSpace: 'nowrap', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis',
            maxWidth: '150px'
          }}>
            {course.name}
          </p>
          {course.locked && course.comingSoon && (
            <FontAwesomeIcon icon={faClock} className="ml-2 has-text-warning" style={{ flexShrink: 0 }} />
          )}
          {course.locked && !course.comingSoon && (
            <FontAwesomeIcon icon={faLock} className="ml-2 has-text-warning" style={{ flexShrink: 0 }} />
          )}
        </div>
        <progress className="progress is-warning" value={course.completed} max="100" style={{ width: '120px', margin: '0 15px', flexShrink: 0 }}>
          {course.completed}%
        </progress>
        <span className="has-text-warning" style={{ minWidth: '80px', textAlign: 'center', flexShrink: 0 }}>{course.completed}% completed</span>
        {course.locked ? (
          <div style={{ minWidth: course.comingSoon ? '100px' : '60px', textAlign: 'right', flexShrink: 0 }}>
            {course.comingSoon ? (
              <button
                type="button"
                className="button is-small is-dark"
                disabled
                style={{
                  width: '100%',
                  opacity: 0.6,
                  cursor: 'not-allowed',
                  border: 'none'
                }}
              >
                Available Soon
              </button>
            ) : (
              <Link to="/joinuniversity" style={{ color: 'inherit', textDecoration: 'none' }}>
                <div 
                  className="has-text-warning" 
                  style={{ 
                    cursor: 'pointer',
                    position: 'relative',
                    display: 'inline-block'
                  }}
                  onMouseEnter={() => setHoveredLock(index)}
                  onMouseLeave={() => setHoveredLock(null)}
                >
                  <FontAwesomeIcon icon={faLock} />
                  {hoveredLock === index && (
                    <div style={{
                      position: 'absolute',
                      bottom: '100%',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      backgroundColor: '#363636',
                      color: '#ffdd57',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      whiteSpace: 'nowrap',
                      zIndex: 1000,
                      marginBottom: '5px'
                    }}>
                      {!isGold ? "Join the university here" : "Complete prerequisite courses first"}
                    </div>
                  )}
                </div>
              </Link>
            )}
          </div>
        ) : (
          <Link to={course.path} style={{ minWidth: '100px', textAlign: 'right', flexShrink: 0 }}>
            <button className="button is-small is-warning">Start Course</button>
          </Link>
        )}
      </div>
    </div>
  );

  return (
    <DynamicLayout>
      <div
        className="full-screen-image-container heightauto margin-top-0"
        style={{
          backgroundImage: `url(${saturnwallpaper})`,
        }}
      >
        <section className="section hasbackgroundgrey heightauto has-text-centered">
          <h2 className="title has-text-centered has-text-warning">
            Welcome to the Saturn Academy.
          </h2>
          <h3 className="subtitle has-text-centered has-text-warning">
            Here you will find the current offering of courses.
          </h3>

          {courses.map(renderCourse)}

          <h2 className="title has-text-centered has-text-warning mt-6">
            Specializations
          </h2>
        
          <p className="has-text-warning">
            {specializations.map(renderCourse)}
          </p>
        </section>
      </div>
    </DynamicLayout>
  );
};

export default AcademyPage;
